<!-- Read-only stars are one value, not five buttons; editable stars say which one is picked. -->
@if (readonly) {
  <span class="sr-only">Rated {{ rating }} out of {{ max }} stars</span>
}
@for (star of stars; track star) {
  @if (readonly) {
    <span [class.icon-star-rated]="isStarFilled(star)" [class.icon-star]="!isStarFilled(star)" aria-hidden="true"></span>
  } @else {
    <span
      [class.icon-star-rated]="isStarFilled(star)"
      [class.icon-star]="!isStarFilled(star)"
      class="clickable"
      (click)="onStarClick(star)"
      [attr.aria-label]="'Rate ' + star + ' out of ' + max + ' stars'"
      [attr.aria-pressed]="star === rating"
      tabindex="0"
      (keydown.enter)="onStarClick(star)"
      (keydown.space)="$event.preventDefault(); onStarClick(star)"
      role="button">
    </span>
  }
}
